// src/components/ambassadors/StatCard.tsx
import { motion } from "framer-motion";

interface StatCardProps {
  value: string;
  label: string;
}

export function StatCard({ value, label }: StatCardProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.02, y: -2 }}
      className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 text-center"
    >
      <p className="text-2xl md:text-3xl font-black text-white mb-1">{value}</p>
      <p className="text-[9px] md:text-[10px] uppercase tracking-wider text-white/40">{label}</p>
    </motion.div>
  );
}
